import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const ITEMS = [
    { id: 'blog', text: 'Blog Actualités' },
    { id: 'chat', text: 'Chatbot IA' },
    { id: 'pay', text: 'Paiement en ligne' },
    { id: 'seo', text: 'Référencement Local' },
    { id: 'nl', text: 'Newsletter Auto' },
    { id: 'rev', text: 'Système Avis' },
    { id: 'social', text: 'Feed Instagram' },
    { id: 'video', text: 'Vidéo Fond' },
];

export default function CommercialSorterPage() {
    const navigate = useNavigate();

    // items in 'bank' (left) or 'must', 'nice', 'bonus' (columns)
    const [buckets, setBuckets] = useState({
        bank: ITEMS,
        must: [],
        nice: [],
        bonus: []
    });

    const moveItem = (itemId, targetBucket) => {
        // Find where item is
        let sourceBucket = '';
        let item = null;
        Object.keys(buckets).forEach(key => {
            const found = buckets[key].find(i => i.id === itemId);
            if (found) { sourceBucket = key; item = found; }
        });

        if (!item || sourceBucket === targetBucket) return;

        setBuckets(prev => ({
            ...prev,
            [sourceBucket]: prev[sourceBucket].filter(i => i.id !== itemId),
            [targetBucket]: [...prev[targetBucket], item]
        }));
    };

    return (
        <div style={{ height: '100vh', width: '100vw', background: '#334155', color: 'white', fontFamily: 'Inter, sans-serif', padding: 20, display: 'flex', flexDirection: 'column' }}>

            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 20 }}>
                <h1 style={{ margin: 0 }}>🗂️ Le Trieur</h1>
                <button onClick={() => navigate('/commercial/launchpad')} style={{ background: 'transparent', border: 'none', color: 'rgba(255,255,255,0.5)', cursor: 'pointer' }}>Retour</button>
            </div>

            <div style={{ flex: 1, display: 'flex', gap: 20, overflow: 'hidden' }}>

                {/* BANK */}
                <div style={{ width: 250, background: '#1e293b', borderRadius: 16, padding: 20, display: 'flex', flexDirection: 'column', gap: 10 }}>
                    <div style={{ opacity: 0.5, fontWeight: 700, marginBottom: 10 }}>FONCTIONNALITÉS</div>
                    {buckets.bank.map(item => (
                        <div
                            key={item.id}
                            onClick={() => moveItem(item.id, 'must')} // click simply moves to first col for demo, or drag logic
                            style={{ padding: 15, background: 'white', color: '#1e293b', borderRadius: 8, cursor: 'pointer', fontWeight: 600 }}
                        >
                            {item.text}
                        </div>
                    ))}
                </div>

                {/* COLUMNS */}
                <div style={{ flex: 1, display: 'flex', gap: 20 }}>
                    {/* MUST HAVE */}
                    <div className="bucket" onClick={() => { }} style={{ flex: 1, background: '#ef4444', borderRadius: 16, padding: 20 }}>
                        <h2 style={{ fontSize: '1.2rem', color: 'white', textAlign: 'center' }}>VITAL (Must Have)</h2>
                        <div style={{ marginTop: 20, display: 'flex', flexDirection: 'column', gap: 10, minHeight: 200 }}>
                            {buckets.must.map(item => (
                                <div key={item.id} onClick={() => moveItem(item.id, 'nice')} style={{ padding: 15, background: 'rgba(255,255,255,0.9)', color: '#b91c1c', borderRadius: 8, cursor: 'pointer', fontWeight: 700 }}>{item.text}</div>
                            ))}
                        </div>
                    </div>

                    {/* NICE TO HAVE */}
                    <div className="bucket" style={{ flex: 1, background: '#f59e0b', borderRadius: 16, padding: 20 }}>
                        <h2 style={{ fontSize: '1.2rem', color: 'white', textAlign: 'center' }}>CONFORT (Nice to Have)</h2>
                        <div style={{ marginTop: 20, display: 'flex', flexDirection: 'column', gap: 10, minHeight: 200 }}>
                            {buckets.nice.map(item => (
                                <div key={item.id} onClick={() => moveItem(item.id, 'bonus')} style={{ padding: 15, background: 'rgba(255,255,255,0.9)', color: '#b45309', borderRadius: 8, cursor: 'pointer', fontWeight: 700 }}>{item.text}</div>
                            ))}
                        </div>
                    </div>

                    {/* BONUS */}
                    <div className="bucket" style={{ flex: 1, background: '#3b82f6', borderRadius: 16, padding: 20 }}>
                        <h2 style={{ fontSize: '1.2rem', color: 'white', textAlign: 'center' }}>LUXE (Bonus)</h2>
                        <div style={{ marginTop: 20, display: 'flex', flexDirection: 'column', gap: 10, minHeight: 200 }}>
                            {buckets.bonus.map(item => (
                                <div key={item.id} onClick={() => moveItem(item.id, 'bank')} style={{ padding: 15, background: 'rgba(255,255,255,0.9)', color: '#1d4ed8', borderRadius: 8, cursor: 'pointer', fontWeight: 700 }}>{item.text}</div>
                            ))}
                        </div>
                    </div>
                </div>

            </div>

            <div style={{ textAlign: 'center', marginTop: 20, opacity: 0.6 }}>Cliquez sur les cartes pour les déplacer vers la droite (cycle).</div>
        </div>
    );
}
